import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
    Alert,
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    IconButton,
    Input,
    InputAdornment,
    InputLabel,
    TextField,
    Typography,
} from "@mui/material";
import { GoogleLogin } from "@react-oauth/google";
import { ApiService } from "common/services/ApiService";
import React, { useState } from "react";

const LogInForm = ({
    logInFormData,
    setLogInFormData,
    setOpenLoader,
    handleLogIn,
    handleChangeForms,
    handleClose,
    setShowError,
    showError,
    errorMessage,
    setConfigurationGoogle,
}) => {
    const [emailError, setEmailError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const checkLoginFormData = (evt) => {
        evt.preventDefault();
        setShowError(false);
        if (!logInFormData.email.trim()) {
            setEmailError(true);
            return;
        } else {
            setEmailError(false);
        }
        if (!logInFormData.password.trim()) {
            setPasswordError(true);
            return;
        } else {
            setPasswordError(false);
        }

        handleLogIn();
    };

    const handleLoginSuccess = async (response) => {
        const credential = response.credential;
        setOpenLoader(true);
        try {
            const data = { credential };
            const res = await ApiService.loginGoogle(data);
            setConfigurationGoogle(res.data);
            setOpenLoader(false);
        } catch (error) {
            console.log("Login failed:", error);
            setOpenLoader(false);
        }
    };

    return (
        <>
            <form>
                <DialogTitle sx={{ width: { md: "500px" } }}>Iniciar Sesión</DialogTitle>
                <DialogContent>
                    <TextField
                        error={emailError}
                        helperText={emailError ? "El email es requerido" : ""}
                        autoFocus
                        margin="dense"
                        id="username"
                        label="Nombre de usuario"
                        type="text"
                        fullWidth
                        variant="standard"
                        onChange={(evt) => {
                            setLogInFormData({
                                email: evt.target.value,
                                password: logInFormData.password,
                            });
                            setEmailError(false);
                        }}
                    />
                    <FormControl variant="standard" fullWidth margin="dense" required>
                        <InputLabel>Contraseña</InputLabel>
                        <Input
                            inputProps={{
                                autoComplete: "new-password",
                            }}
                            fullWidth
                            error={passwordError}
                            type={showPassword ? "text" : "password"}
                            onChange={(evt) => {
                                setLogInFormData({
                                    email: logInFormData.email,
                                    password: evt.target.value,
                                });
                                setPasswordError(false);
                            }}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label={showPassword ? "Ocultar" : "Ver"}
                                        onClick={handleClickShowPassword}
                                        // onMouseDown={handleMouseDownPassword}
                                        // onMouseUp={handleMouseUpPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                        {passwordError && (
                            <small style={{ color: "red" }}> La contraseña es requerida </small>
                        )}
                    </FormControl>
                    <div style={{ marginTop: "10px" }}>
                        <Typography variant="p">
                            <small>
                                Todavía no tienes cuenta?{" "}
                                <Typography
                                    variant="p"
                                    sx={{
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                    }}
                                    color={"primary.dark"}
                                    onClick={() => {
                                        handleChangeForms();
                                    }}
                                >
                                    Registrate
                                </Typography>
                            </small>
                        </Typography>
                    </div>
                    <div style={{ marginTop: "10px", textAlign: "center" }}>
                        <GoogleLogin
                            onSuccess={handleLoginSuccess}
                            onError={() => console.log("Login Failed")}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleClose}
                        variant="contained"
                        sx={{ backgroundColor: "primary.light" }}
                    >
                        Cancelar
                    </Button>
                    <Button type="submit" variant="contained" onClick={checkLoginFormData}>
                        Iniciar Sesión
                    </Button>
                </DialogActions>
            </form>
            {showError && (
                <Grid
                    item
                    xs={12}
                    md={7}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        padding: "12px",
                    }}
                >
                    <Alert severity="error">{errorMessage}</Alert>
                </Grid>
            )}
        </>
    );
};

export default LogInForm;
